import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { SafeArea } from "capacitor-plugin-safe-area";

if (environment.production) {
  enableProdMode();
}

// Initialize SafeArea CSS variables without blocking bootstrap
(async function initSafeArea() {
  try {
    const { insets } = await SafeArea.getSafeAreaInsets();
    const root = document.documentElement;
    root.style.setProperty("--computed-safe-area-top", `${insets.top}px`);
    root.style.setProperty("--computed-safe-area-bottom", `${insets.bottom}px`);
    root.style.setProperty("--computed-safe-area-left", `${insets.left}px`);
    root.style.setProperty("--computed-safe-area-right", `${insets.right}px`);

    // Only add listener if getSafeAreaInsets succeeded
    try {
      // Update on changes (e.g., rotation, status bar visibility)
      await SafeArea.addListener("safeAreaChanged", ({ insets }) => {
        const root = document.documentElement;
        root.style.setProperty("--computed-safe-area-top", `${insets.top}px`);
        root.style.setProperty(
          "--computed-safe-area-bottom",
          `${insets.bottom}px`
        );
        root.style.setProperty("--computed-safe-area-left", `${insets.left}px`);
        root.style.setProperty(
          "--computed-safe-area-right",
          `${insets.right}px`
        );
      });
    } catch (e) {
      // Listener not available on some platforms; ignore
    }
  } catch (e) {
    // Ignore if plugin not available (web/desktop); CSS env() fallback will apply
    // console.warn('SafeArea init failed', e);
  }
})().catch(() => {
  // Catch any unhandled promise rejections from SafeArea
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
